/**
 * @param {ReturnType<typeof import('widgets/checkout/PaymentAccordionItem').default>} PaymentAccordionItem Base widget for extending
 * @returns {typeof PaymentAccordionItemZEROPAYMENT} Zero Payment Accordion Item widget
 */
export default function (PaymentAccordionItem) {
    /**
     * @category widgets
     * @subcategory checkout
     * @class PaymentAccordionItemZEROPAYMENT
     * @augments PaymentAccordionItem
     * @classdesc Represents PaymentAccordionItemZEROPAYMENT component with the next features:
     * 1. Handles payment tab submit
     * 2. Validates payment tab child elements
     *
     * @example <caption>Example of PaymentAccordionItemZEROPAYMENT widget usage</caption>
     *  <section
     *      data-widget="paymentAccordionItem${paymentOption.ID}"
     *      data-widget-event-closeallitems="closeItems"
     *      data-method-id="${paymentOption.ID}"
     *      data-method-name="${paymentOption.name}"
     *      class="b-payment_accordion-item"
     *  >
     *      <isinclude template="${'checkout/billing/paymentOptions/paymentTitle_' + paymentOption.ID}" />
     *      <div
     *          id="payment-details-${paymentOption.ID}"
     *          data-ref="accordionItemPanel"
     *          class="b-payment_accordion-content"
     *      >
     *          <div class="b-payment_accordion-content_inner" data-ref="accordionItemPanelInner">
     *              <isinclude template="${'checkout/billing/paymentOptions/paymentBody_' + paymentOption.ID}" />
     *          </div>
     *      </div>
     *  </section>
     */
    class PaymentAccordionItemAPPLEPAY extends PaymentAccordionItem {
        /**
         * @description Handles zero payment tab submit
         * @returns {Promise} result
         */
        process() {
            return Promise.resolve([]);
        }

        /**
         * @description Validates zero payment tab child elements.
         * @returns {boolean} validation result
         */
        isChildrenValid() {
            return true;
        }

        activatePayment() {}

        /**
         * @description Clean up sensitive data handler
         * @returns {void}
         */
        cleanupSensitiveData() { }
    }

    return PaymentAccordionItemAPPLEPAY;
}
